export const relationConfiguration = {
    relationNotSetId: 0
};
